import {
  Component, Input, OnInit, ViewContainerRef, ViewChild, ReflectiveInjector, ComponentFactoryResolver, OnDestroy,
  Compiler,
  ComponentFactory,
  ModuleWithComponentFactories,
  ComponentRef, Injector, ElementRef, Type
} from '@angular/core';
import { Subscription } from 'rxjs';
import * as d3 from 'd3';
import { Widget, NotificationService, LogService } from 'core-dashboard';
import { HomeComponent } from '../home.component/home.component';

@Component({
  selector: 'WidgetPlaceholder',
  template: `<div style="height:100%;width:100%">
<div  #titleContainer class="d3-chartTitle">{{chartTitle}}</div>
<div #widgetContainer>
<template #dynamicComponentContainer></template>
</div></div>`
})

export class WidgetPlaceholder implements OnInit, OnDestroy {

  currentComponent: any;
  widgetConfig: string;
  public chartTitle: string;
  // public showTitle: boolean = true;
  subscription: any;

  ngOnChanges() {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.subscription = this.notificationService.changeAnnounced$.subscribe(
      mission => {
        this.onSizeChange(mission);
      });
  }

  onSizeChange(id: any) {
    if (this.currentComponent) {
      if (this.currentComponent.instance !== null && typeof this.currentComponent.instance.createChart !== "undefined") {
        setTimeout(() => {

          this.currentComponent.instance.createChart();
        }, 300);
      }
    }
  }

  @ViewChild('dynamicComponentContainer', {
    read: ViewContainerRef,
    static: true
  }) dynamicComponentContainer: ViewContainerRef;
  @ViewChild('titleContainer',{static:true}) titleContainer: ElementRef;
  @ViewChild('widgetContainer',{static:true}) widgetContainer: ElementRef;
  constructor(private viewref: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private logger: LogService,
    private compiler: Compiler, private inj: Injector, private notificationService: NotificationService) {
  }

  // component: Class for the component you want to create
  // inputs: An object with key/value pairs mapped to input name/input value
  @Input() set componentData(data: { id: any, name: any, component: any, inputs: any }) {
    try {
      if (!data) {
        return;
      }
      // Inputs need to be in the following format to be resolved properly
      //let inputProviders = Object.keys(data.inputs).map((inputName) => {return {provide: inputName, useValue: data.inputs[inputName]};});
      let inputProviders: any = [];
      let providerName = data.inputs.dataProvider.name;
     
      inputProviders.push({ provide: providerName, useClass: data.inputs.dataProviderInstance });
      inputProviders.push({ provide: "dataProvider", useValue: data.inputs.dataProvider });
      inputProviders.push({ provide: "config", useValue: data.inputs.config });
      inputProviders.push({ provide: "widgetStyle", useValue: data.inputs.style });
      inputProviders.push({ provide: "dashboardMargins", useValue: data.inputs.dashoboardMargins });
      //let resolvedInputs = ReflectiveInjector.resolve(inputProviders);

      // We create an injector out of the data we want to pass down and this components injector
      //let injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, this.dynamicComponentContainer.parentInjector);
      //let injector = ReflectiveInjector.resolveAndCreate(inputProviders, this.inj)
      //let injector = ReflectiveInjector.resolveAndCreate(inputProviders, this.inj)
///alert(injector);
      //let provider = injector.get(data.inputs.ProviderName);
      //let provider = injector.get(data.inputs.ProviderName);
      // We create a factory out of the component we want to create
      //let factory = this.resolver.resolveComponentFactory(data.component);
//alert(factory);
      // We create the component using the factory and the injector
      ///let component = factory.create(injector);
     // let injector = ReflectiveInjector.resolveAndCreate(inputProviders);
     

      //let provider = injector.get(data.inputs.ProviderName);
      //let provider = injector.get(data.inputs.ProviderName);
      // We create a factory out of the component we want to create
      //let factory = this.resolver.resolveComponentFactory(data.component);

      // We create the component using the factory and the injector
      //let component = factory.create(injector);
     
      const injector: Injector = Injector.create({
        providers: inputProviders,parent:this.inj
      }
      
      );
      
      const viewContainerRef = this.dynamicComponentContainer;
     
    viewContainerRef.clear();
   
    
      let component=viewContainerRef.createComponent(data.component,{injector:injector});
      //let component = factory.create(injector);

      let widget = component.instance as Widget;
      if (widget) {
        widget.id = data.id;
        widget.NAME = data.name;
        widget.Config = data.inputs.config;
        widget.SetTransaltion();
      }
      this.applyStyles(component.instance);
      // We insert the component into the dom container
      this.dynamicComponentContainer.insert(component.hostView);

      // Destroy the previously created component
      if (this.currentComponent) {
        this.currentComponent.destroy();
      }
      this.currentComponent = component;
    } catch (error) {
      this.logger.logError("WidgetPlaceholder", "Error while creating instance of " + data.name + ". " + error);
    }

  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); } //Unsubscribe 
  }

  applyStyles(component: any) {
    let widget = this.widgetContainer.nativeElement;
    d3.select(widget).style('height', '100%');
    var titleHeight = component.currentStyle.title_visible ? component.currentStyle && component.currentStyle.title_font_size ? (component.currentStyle.title_font_size + 5) : 20 : 0;
    let titleElement = this.titleContainer.nativeElement;
    if (component.currentStyle && component.currentStyle.title_visible) {
      this.chartTitle = component.NAME ? component.NAME : "Chart";
      d3.select(titleElement).style('color', component.currentStyle.title_font_color)
        .style('text-align', 'center')
        .style('height', ((component.currentStyle.title_font_size + 5) + "px"))
        .style('font-size', (component.currentStyle.title_font_size + "px"))
        .style('font-family', component.currentStyle.title_font).style("background-color", component.currentStyle.title_background_color)
    }
    else {
      // this.showTitle = false;
      titleElement.innerHtml = "";
    }
    d3.select(widget).style('height', 'calc(100% - ' + titleElement.clientHeight + 'px)').style('width', '100%')

  }
}



